var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAlertIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 32,
    viewBox: "0 0 36 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6828",
    "data-name": "Group 6828",
    transform: "translate(-162 -226)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Polygon_37",
    "data-name": "Polygon 37",
    d: "M14.514,6.2a4,4,0,0,1,6.973,0L32.647,26.039A4,4,0,0,1,29.161,32H6.839a4,4,0,0,1-3.486-5.961Z",
    transform: "translate(162 226)",
    fill: "#d66b6b"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_6826",
    "data-name": "Group 6826",
    transform: "translate(4062.5 5476.124)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23442",
    "data-name": "Path 23442",
    d: "M0,0V8.574",
    transform: "translate(-3882.5 -5237.956)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23443",
    "data-name": "Path 23443",
    d: "M0,0H0",
    transform: "translate(-3882.5 -5223.969)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 3
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertIcon);
export default __webpack_public_path__ + "static/media/alert-icon.c658b286.svg";
export { ForwardRef as ReactComponent };